import { httpRequest } from '@/services/httpClient'

export type UserItem = {
  userId: number
  tenantId: number | null
  userName: string
  email: string | null
  phone: string | null
  isActive: boolean
  createdAt: string
  lastUpdated: string
}

export type UserListResponse = {
  items: UserItem[]
  totalCount: number
  page: number
  pageSize: number
}

export type UserListParams = {
  search?: string
  tenantId?: number
  isActive?: boolean
  page?: number
  pageSize?: number
  sortBy?: string
  sortDir?: 'asc' | 'desc'
}

export type UserCreatePayload = {
  userName: string
  email?: string | null
  phone?: string | null
  password?: string | null
  tenantId?: number | null
}

export type UserCreateResponse = {
  id: number
  userName: string
}

export type UserUpdatePayload = {
  email?: string | null
  phone?: string | null
  isActive?: boolean
}

export const usersApi = {
  list: (params: UserListParams) =>
    httpRequest<UserListResponse>('/v1/users', {
      method: 'GET',
      query: {
        search: params.search?.trim() || undefined,
        tenantId: params.tenantId ?? undefined,
        isActive: params.isActive ?? undefined,
        page: params.page ?? 1,
        pageSize: params.pageSize ?? 20,
        sortBy: params.sortBy,
        sortDir: params.sortDir,
      },
    }),

  getById: (id: number) =>
    httpRequest<UserItem>(`/v1/users/${id}`, { method: 'GET' }),

  create: (payload: UserCreatePayload) =>
    httpRequest<UserCreateResponse>('/v1/users', {
      method: 'POST',
      body: {
        userName: payload.userName.trim(),
        email: payload.email?.trim() || null,
        phone: payload.phone?.trim() || null,
        password: payload.password || null,
        tenantId: payload.tenantId ?? null,
      },
    }),

  update: (id: number, payload: UserUpdatePayload) =>
    httpRequest<UserCreateResponse>(`/v1/users/${id}`, {
      method: 'PUT',
      body: {
        email: payload.email?.trim() || null,
        phone: payload.phone?.trim() || null,
        isActive: payload.isActive ?? true,
      },
    }),
}
